import React, { useState } from 'react';
import { Dropdown, Menu, Input, message as antMessage } from 'antd';
import {
  MessageOutlined,
  MoreOutlined,
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Modal } from 'antd';
import styles from '../../styles/chatV2.module.css';

const { confirm } = Modal;

const ConversationItem = ({
  conversation,
  isActive,
  onSelect,
  onDelete,
  onRename,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedTitle, setEditedTitle] = useState(conversation.title);

  const handleRename = () => {
    if (editedTitle.trim() && editedTitle !== conversation.title) {
      onRename(editedTitle);
    }
    setIsEditing(false);
  };

  const handleDelete = () => {
    confirm({
      title: 'Delete Conversation',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure you want to delete this conversation?',
      okText: 'Delete',
      okType: 'danger',
      onOk: onDelete,
    });
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="rename"
        icon={<EditOutlined />}
        onClick={() => setIsEditing(true)}
      >
        Rename
      </Menu.Item>
      <Menu.Item
        key="delete"
        icon={<DeleteOutlined />}
        danger
        onClick={handleDelete}
      >
        Delete
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      className={`${styles.conversationItem} ${
        isActive ? styles.conversationItemActive : ''
      }`}
    >
      {isEditing ? (
        <Input
          value={editedTitle}
          onChange={(e) => setEditedTitle(e.target.value)}
          onBlur={handleRename}
          onPressEnter={handleRename}
          autoFocus
          size="small"
        />
      ) : (
        <>
          <div className={styles.conversationContent} onClick={onSelect}>
            <MessageOutlined className={styles.conversationIcon} />
            <div className={styles.conversationInfo}>
              <div className={styles.conversationTitle}>
                {conversation.title}
              </div>
              <div className={styles.conversationMeta}>
                {conversation.messageCount} messages •{' '}
                {new Date(
                  conversation.updatedAt || conversation.createdAt
                ).toLocaleDateString()}
              </div>
            </div>
          </div>

          <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
            <button
              className={styles.conversationActions}
              onClick={(e) => e.stopPropagation()}
            >
              <MoreOutlined />
            </button>
          </Dropdown>
        </>
      )}
    </div>
  );
};

export default ConversationItem;
